module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAMBAMAAADxOqKKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUxpcf///////////////////////////////////////////////////+bWS5kAAAANdFJOUwAPIO/D1QrMF7R4li9EvEMUAAAARElEQVQI12NgQALKCxhQge5tdIG709AFrggwJAoiwNm7d4MYau+igCuYAkg6BIVBWpAB892rDWgCFajWMgNtRRUAugsAcP8sFQh2MCQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next_page.png
// module id = R25e
// module chunks = 0